<script>

	import JsBarcode from "jsbarcode";
	import BarcodePart from "./BarcodePart.svelte";
	import jsPDF from 'jspdf';

	let barcodeParts = [
		{
			name: "sap",
			prefix: "(02)",
			required: true,
			value: "",
		},
			{
			name: "container id",
			prefix: "(00)",
			required: true,
			value: "",
		},
			{
			name: "best before date",
			prefix: "(15)",
			required: true,
			value: "",
		},
			{
			name: "production date",
			prefix: "(11)",
			required: true,
			value: "",
		},
			{
			name: "batch",
			prefix: "(10)",
			required: true,
			value: "",
		},	{
			name: "quantity",
			prefix: "(37)",
			required: true,
			value: "",
		}
	];
	let barcodeRecipe = ``;
	let barcodeText = ``;
	let btnIsDisabled = true;
	let title = "";


	function handleSubmit() {
		const barcodeRecipe = barcodeParts.map(part => part.value).join("");
		const barcodeText = barcodeParts.map(part => part.prefix + part.value).join("");		
		
		JsBarcode("#barcode", barcodeRecipe, {
			text: barcodeText, 
			textMargin: 25,
			// font: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;"
    });
	};

	function reset() {
		const barcodePartsNew = barcodeParts.map(part => {
				return {
					...part,
					value: ""
				}
			});
		barcodeParts = barcodePartsNew;
		const barcodeContainer = document.getElementById("barcode");
		while (barcodeContainer.firstChild) barcodeContainer.removeChild(barcodeContainer.firstChild);
	};

	function handleInput({detail:{name,prefix,value}}) {
		barcodeParts.forEach(part => { if (part.prefix === prefix) part.value = value});
		btnIsDisabled = barcodeParts.filter(part => part.value === "").length;			
	};

	function savePdf() {
    const jpegUrl = document.getElementById("barcode").toDataURL("image/jpeg");
		var doc = new jsPDF();
		doc.text('The text', doc.internal.pageSize.getWidth() / 2, 50, null, null, 'center')
		doc.addImage(jpegUrl, 'JPEG', 15, 40);
		doc.save(`${title}.pdf`);
	};
	

</script>

<div class="container">
  <h2>Please fill below to generate barcode</h2>
	<form on:submit|preventDefault={handleSubmit}>

		{#each barcodeParts as barcodePart}
			<BarcodePart on:inputChange={handleInput} {...barcodePart}/>
		{/each}

		<div class="field-container">
      <input bind:value={title} type="text" class="field" placeholder="Title - optional" />
      <div class="field-underline"></div>
		</div>

		<button on:click={reset} class="btn-reset">Reset fields</button>

	  <button type="submit" disabled={btnIsDisabled}>Generate barcode</button>
      <p>
        Please fill in all fields before generating a barcode
      </p>

			

 	</form>

	 <button on:click={savePdf}>Save PDF</button>

	<h2>{title}</h2>
	<canvas id="barcode"></canvas>

</div>

<style>
.container {
	max-width: 1024px;
	margin: 0 auto;
	text-align: center;
}

h2 {
    text-align: center;
}

 .field-container {
    position: relative;
    margin: 0 auto;
    width: 400px;
    margin-top: 30px;
  }

  .field {
    display: block;
    width: 100%;
    padding: 15px 10px 0;
    border: none;
    font-size: 14px;
  }

  .field:focus {
    outline: 0;
  }

  .floating-label {
    position: absolute;
    pointer-events: none;
    top: 5px;
    left: 10px;
    font-size: 10px;
    opacity: 0;
    background-color: white;
    padding: 0 2px;
    -webkit-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }

  .field:valid+.floating-label {
    opacity: 1;
    top: -5px;
    color: #9e9e9e;
    text-transform: uppercase;
  }

  .field:focus+.floating-label {
    color: #03a9f4;
  }

  .field-underline {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: -5px;
    border: 1px solid #9e9e9e;
    z-index: -1;
    padding: 10px 10px 0;
  }

  .field:focus+.floating-label+.field-underline {
    border-color: #03a9f4;
  }

button {
	margin-top: 2rem;
}

button {
	background-color: #f4f4f4;
	outline: none;
}

button:active {
	background-color: #ddd;
}

button:focus {
	border-color: #666;
}


button {
	margin-top: 2rem;
	padding: .5rem 1rem;
	background-color: #118fe4;
	border-color: transparent;
	color: #fff;
	cursor: pointer;
	transition: all .35s ease-in-out;
	box-shadow: 4px 4px 10px 1px rgba(0,0,0,.2);
}

button+p {
	opacity: 0;
	color: red;
	transition: all .35s ease-in-out;
}

button[disabled] {
	background-color: #209cee;
	border-color: transparent;
	box-shadow: none;
	cursor: not-allowed;
	opacity: .35;
}

button[disabled]:hover+p {
	opacity: 1;
}

.btn-reset {
	background-color: rgb(251, 255, 0);
	color: black;
	margin: 1rem;
}

</style>

